export default {
  title: "Politique de confidentialité et conditions d’utilisation des cookies",
  read: "J'ai lu et j'accepte les conditions générales d'utilisation",
  text_nominale_footer: `
    <p>
    PlayYourJob est une plateforme de Laborplay S.r.l., TVA n° 06563810487 avec siège social à : Via Madonna del Piano n. 6, Sesto Fiorentino (FI) 
    email:&#32; 
    <a href="mailto:privacy@laborplay.com">privacy@laborplay.com</a> ;
    pec:&#32;
    <a href="mailto:laborplay@legalmail.it">laborplay@legalmail.it</a>.
    </p>
    <h5>
    INFORMATIONS SUR LE TRAITEMENT DES DONNÉES PERSONNELLES CONFORMÉMENT À L'ARTICLE 13 DU RÈGLEMENT UE 2016/679 (RGPD)
    </h5>
    <h6>1. Propriétaire et responsables du traitement des données</h6>
    <p>
    Le responsable du traitement des données est : Laborplay S.r.l., n° de TVA : 06563810487, dont le siège social est situé à : Via Madonna del Piano, n° 6, Sesto Fiorentino (FI), que vous pouvez contacter pour exercer vos droits en vertu du RGPD et obtenir la liste actualisée de tous les sous-traitants désignés.
    </p>
    <p>Le représentant légal est: Elena Gaiffi.</p>
    <p>
    Le responsable du traitement des données peut être contacté aux coordonnées suivantes:
    </p>
    <p>email: privacy@laborplay.com; pec: laborplay@legalmail.it.</p>
    <p>
    Le responsable du traitement a nommé le délégué à la protection des données (“R.P.D.”) l’Ing. Andrea Appicciafuoco
    (email: rpd.appicciafuoco@gmail.com).
    </p>
    <h6>2. Finalité du traitement</h6>
    <p>
    Les données personnelles fournies peuvent être traitées uniquement aux fins suivantes : exécution du service proposé par le Responsable du traitement ; envoi de communications de service ; respect des obligations légales et réponse aux demandes des autorités.
    </p>
    <p>
    Aucun traitement ultérieur fondé sur les intérêts légitimes poursuivis par le Responsable du traitement n’est envisagé.
    </p>
    <h6>3. Base juridique du traitement</h6>
    <p>
    Le Responsable du traitement traite les données personnelles de manière licite lorsque le traitement :
    </p>
    <ul>
    <li>
        est nécessaire à l'exécution d'un contrat auquel la personne concernée est partie ou à la mise en œuvre de mesures précontractuelles prises à la demande de la personne concernée;
    </li>
    <li>
        est fondée sur le consentement exprès de la partie intéressée pour une ou plusieurs finalités ;
    </li>
    <li>
        est nécessaire pour remplir une obligation légale à laquelle le Responsable du traitement est soumis.
    </li>
    </ul>
    <h6>4. Types de données traitées</h6>
    <p>
    Données communes (par exemple : année de naissance, sexe).
    </p>
    <p>
    Les données des personnes n'ayant pas atteint l'âge minimum requis par la législation en vigueur (mineurs) ne seront pas traitées. Le Responsable du traitement n'utilise pas de cookies ; par conséquent, les données issues de leur utilisation ne seront pas traitées.
    </p>
    <h6>5. Conséquences du défaut de communication des données personnelles</h6>
    <p>
    La fourniture de données personnelles est nécessaire pour utiliser le service proposé par le Responsable du traitement.
    </p>
    <h6>6. Communication et diffusion des données</h6>
    <p>
    Les données ne peuvent être communiquées qu'à la personne concernée, à la société avec laquelle le Responsable du traitement a conclu un contrat d'utilisation de l'application web dont il est propriétaire ; pour satisfaire à une obligation légale à laquelle le Responsable du traitement est soumis, ou lorsque cela est nécessaire à l'exécution d'une mission d'intérêt public qui lui est confiée. Dans les limites
pertinentes aux finalités de traitement indiquées ci-dessus, vos données peuvent être communiquées à:
    </p>
    <ul>
    <li>
        L'entreprise ayant signé le contrat d'utilisation de l'application web
appartient au propriétaire;
    </li>
    <li>
        employés ou collaborateurs du Responsable du traitement classés comme « personnes autorisées » ;
    </li>
    <li>
        autorités judiciaires ou administratives, pour l'exécution d'obligations légales.
    </li>
    </ul>
    <p>
    Les données ne seront pas divulguées. Elles ne seront pas transférées à un pays tiers ni à une organisation internationale.
    </p>
    <h6>7. Profilage </h6>
    <p>
    
Vos données personnelles ne feront l'objet d'un profilage qu'avec votre consentement exprès. Le profilage est réalisé par l'utilisation de l'application du Responsable du traitement par l'Utilisateur.
    </p>
    <h6>8. Méthodes de traitement</h6>
    <p>
    Le traitement des données personnelles consiste en la collecte, l'enregistrement, l'organisation, la structuration, la conservation, l'adaptation ou la modification, l'extraction, la consultation, l'utilisation, la communication, la diffusion, la comparaison ou l'interconnexion, la limitation, l'effacement ou la destruction de ces données.
    </p>
    <p>
    Les données personnelles sont traitées aux fins énoncées ci-dessus, conformément à l'article 5 du RGPD :
    </p>
    <ul>
    <li>
        Assistance informatique (y compris sur appareils portables) et par voie télématique (par exemple, courrier électronique) ; conformément aux dispositions de l'article 32 du RGPD, dans le cadre de fausses déclarations de sécurité matérielle et conformément aux dispositions de l'article 29 du RGPD.
    </li>
    </ul>
    <h6>9. Conservation des données</h6>
    <p>
    Vos données seront stockées dans le cloud, sur des serveurs situés dans l'Union européenne, et seront conservées pendant la durée nécessaire à la réalisation des finalités indiquées.
    </p>
    <p>
    Vos données seront conservées pendant toute la durée du contrat conclu pour l'utilisation de l'application web appartenant au Responsable du traitement, puis pendant 30 jours supplémentaires à compter de l'expiration dudit contrat. Passé ce délai, vos données personnelles seront supprimées.&#32;
    </p>
    <h6>10. Droits de l'intéressé</h6>
    <p>L'intéressé a le droit:</p>
    <ul>
    <li>
        de demander l'accès à vos données personnelles et aux informations associées auprès du Responsable du traitement, en utilisant les coordonnées indiquées au point 1 (voir article 15 du RGPD).;&#32;
    </li>
    <li>
        à la rectification des données inexactes ou à l'intégration des données incomplètes (voir art. 16 RGPD) ;&#32;
    </li>
    <li>
        à l'effacement (dit « droit à l'oubli ») des données personnelles le concernant (lorsque l'une des conditions indiquées à l'article 17, paragraphe 1, du RGPD s'applique, et sous réserve des exceptions prévues au paragraphe 3 du même article) ;&#32;
    </li>
    <li>
        de restreindre le traitement de vos données personnelles (si l'une des conditions énoncées à l'article 18, paragraphe 1, du RGPD s'applique) ;
    </li>
    <li>
        de demander et d'obtenir du Responsable du traitement – en utilisant les coordonnées indiquées au point 1 et dans les cas où la base juridique du traitement est un contrat ou un consentement et où le traitement est effectué par des moyens automatisés – vos données personnelles dans un format structuré et lisible par machine, également aux fins de communication de ces données à un autre responsable du traitement (droit à la portabilité des données, voir article 20 du RGPD) ;
    </li>
    <li>
        de vous opposer à tout moment au traitement de vos données personnelles
en cas de situation particulière vous concernant
(voir article 21 du RGPD) ;
    </li>
    <li>
        de retirer son consentement au traitement, en utilisant les coordonnées indiquées au point 1, sans préjudice de la licéité du traitement fondé sur le consentement obtenu avant le retrait ;
    </li>
    <li>
        de déposer une plainte auprès de l'Autorité de protection des données personnelles
située à Piazza di Monte Citorio 121, Rome, ou auprès des autorités de contrôle
désignées par cette dernière (voir article 77 du RGPD) par les moyens suivants :
        <ul>
        Courrier recommandé avec accusé de réception adressé à l'Autorité italienne de protection des données
à l'adresse ci-dessus • Courriel : garante@gpdp.it ou courriel certifié : protocollo@pec.gdpd.it
        </ul>
    </li>
    </ul>
`,
  text_nominale: `
    <p>
    PlayYourJob est une plateforme de Laborplay S.r.l., TVA n° 06563810487 avec siège social à : Via Madonna del Piano n. 6, Sesto Fiorentino (FI)
    email:&#32;
    <a href="mailto:privacy@laborplay.com">privacy@laborplay.com</a> ;
    pec:&#32;
    <a href="mailto:laborplay@legalmail.it">laborplay@legalmail.it</a>.
    </p>
    <h5>POLITIQUE SUR LE TRAITEMENT DES DONNÉES PERSONNELLES</h5>
    <h6>1) QU’ENTEND-ON PAR TRAITEMENT DES DONNÉES PERSONNELLES?</h6>
    <p>
    Il s’agit de la collecte, de l’enregistrement, de l’organisation, de la structuration, de la conservation, de l’adaptation ou de la modification, de l’extraction, de la consultation, de l’utilisation, de la communication, de la diffusion, de la comparaison ou de l’interconnexion, de la limitation, de la suppression ou de la destruction de ces données.
    </p>
    <h6>2) QUI TRAITE MES DONNÉES PERSONNELLES?</h6>
    <p>
    Le Responsable du traitement, qui est Laborplay S.r.l., avec siège social à Via Madonna del Piano n. 6, Sesto Fiorentino (FI), TVA n° 06563810487 – E-mail : privacy@laborplay.com ; PEC (adresse électronique certifiée) : laborplay@legalmail.it
    </p>
    <h6>3) À QUELLES FINS MES DONNÉES SONT-ELLES TRAITÉES?</h6>
    <p>
    Pour exécuter le service offert par le Responsable ; pour vous envoyer des communications concernant le service lui-même ; pour remplir les obligations légales et répondre aux demandes des Autorités.
    </p>
    <h6>
    4) QUELLES SONT LES BASES LÉGALES DU TRAITEMENT DE MES DONNÉES?
    </h6>
    <p>
    Nous traitons vos données de manière licite chaque fois que le traitement est nécessaire à l’exécution du contrat auquel vous êtes partie ou à l’exécution de mesures précontractuelles adoptées à votre demande ; cela est basé sur votre consentement exprès, le cas échéant ; cela est nécessaire pour remplir une obligation légale à laquelle le Responsable est soumis ; cela est nécessaire pour la poursuite de l’intérêt légitime du Responsable. Les intérêts légitimes du Responsable comprennent sa protection, celle des personnes concernées ou d’autres sujets contre les menaces à la sécurité ou la fraude, dans le respect de la réglementation en vigueur ; la gestion et l’amélioration de l’entreprise.
    </p>
    <h6>5) QUELLES DONNÉES PERSONNELLES SONT TRAITÉES?</h6>
    <p>
    •	Les données communes fournies par la personne concernée ou par des sujets autorisés-délégués tels que, à titre d’exemple, le sexe et l’année de naissance.
•	Les données communes saisies lors de la compilation du test.
•	Les évaluations et profils générés en interne par Laborplay®.
Nous traiterons les données des mineurs après avoir obtenu le consentement clair et explicite des personnes qui exercent l’autorité parentale.
Le Responsable du traitement n’utilise pas de cookies et, par conséquent, les données provenant de leur utilisation ne seront pas traitées.
    </p>
    <h6>6) QUE SE PASSE-T-IL SI JE NE FOURNIS PAS MES DONNÉES PERSONNELLES? </h6>
    <p>
    Le défaut de communication de vos données ne vous permettra pas d’utiliser le service offert par le Responsable.
    </p>
    <h6>7) À QUI MES DONNÉES SERONT-ELLES COMMUNIQUÉES?</h6>
    <p>
    Vos données pourront être communiquées, dans les limites pertinentes aux fins indiquées ci-dessus :
    </p>
    <p>
    À vous-même ; à la Société avec laquelle le Responsable a conclu le contrat d’utilisation de la web-app appartenant au Responsable ; pour remplir une obligation légale à laquelle est soumis le Responsable du traitement, ou dans la mesure où cela est nécessaire pour l’exécution d’une tâche d’intérêt public dont est investi le Responsable du traitement.
    </p>
    <p>
    Dans les limites pertinentes aux fins de traitement indiquées ci-dessus, vos données pourront être communiquées:
    </p>
    <ul>
    <li>
        à la Société qui a conclu le contrat d’utilisation de la web-app appartenant au Responsable;
    </li>
    <li>
        aux employés ou collaborateurs du Responsable qualifiés de « préposés » ;;
    </li>
    <li>
        &#32;
        aux autorités judiciaires ou administratives, pour l’accomplissement des obligations légales ;
    </li>
    <li>
        aux sujets convenablement désignés « Responsables du traitement » par le Responsable du traitement ou qui fournissent des prestations fonctionnelles aux fins indiquées ci-dessus ;
    </li>
    <li>
        aux sujets qui traitent les données en exécution d’obligations légales spécifiques ;
    </li>
    </ul>
    <p>Vos données ne seront PAS diffusées.</p>
    <p>
    Vos données ne seront PAS transférées vers un pays n’appartenant pas à l’Union européenne ou à une organisation internationale ;&#32;
    </p>
    <h6>8) COMMENT MES DONNÉES SONT-ELLES TRAITÉES? SONT-ELLES PROFILÉES?</h6>
    <p>
    Le traitement de vos données personnelles est effectué sur un support informatique (y compris les appareils portables) conformément aux dispositions de la législation en vigueur.
    </p>
    <p>
    Vos données personnelles feront l’objet d’un profilage, uniquement avec votre consentement exprès. Le profilage est obtenu par l’utilisation par l’Utilisateur de l’application appartenant au Responsable.
    </p>
    <h6>9) COMBIEN DE TEMPS MES DONNÉES SERONT-ELLES CONSERVÉES? </h6>
    <p>
    Vos données seront stockées dans le « cloud », sur des serveurs situés au sein de l’Union européenne et seront conservées pendant le temps nécessaire pour atteindre les objectifs indiqués.
    </p>
    <p>
    Vos données seront conservées pendant la durée du contrat conclu avec la Société pour l’utilisation de la web-app appartenant au Responsable et, par la suite, pendant 30 jours supplémentaires à compter de l’expiration dudit contrat. Passé ce délai, vos données seront effacées.
    </p>
    <h6>
    10) QUELS SONT MES DROITS EN VERTU DE LA LÉGISLATION EN VIGUEUR SUR LA VIE PRIVÉE?
    </h6>
    <p>Vous avez le droit de: </p>
    <ul>
    <li>
        demander au responsable du traitement l’accès aux données personnelles ;
    </li>
    <li>
        rectifier les données inexactes ou compléter les données incomplètes ;
    </li>
    <li>
        supprimer éventuellement vos données personnelles vous concernant (lorsque l’une des conditions énoncées à l’art. 17, paragraphe 1, du RGPD est remplie et sous réserve des exceptions prévues au paragraphe 3 du même article), sans préjudice des dispositions du point 9 de la présente politique ;
    </li>
    <li>
        limiter éventuellement le traitement de vos données personnelles ;
    </li>
    <li>
        si le traitement est effectué par des moyens automatisés (informatiques) et dans la mesure où cela est techniquement possible, recevoir dans un format structuré ou vous transmettre à vous-même ou à des tiers indiqués par vous les informations vous concernant ;
    </li>
    <li>
        retirer votre consentement à tout moment (sans préjudice de la licéité du traitement fondé sur le consentement avant la révocation), bien entendu pour les traitements effectués sur la base de cette condition ;
    </li>
    <li>de révoquer tout consentement au traitement;</li>
    <li>
        Si vous estimez que le traitement de vos données est effectué en violation de la loi applicable, vous pouvez déposer une plainte auprès de l'Autorité italienne de protection des données.
    </li>
    </ul>
`,
  text_anonimo: `
    <p>
    PlayYourJob est une plateforme de Laborplay S.r.l., TVA n° 06563810487 avec siège social à : Via Madonna del Piano n. 6, Sesto Fiorentino (FI) 
    email:&#32;
    <a href="mailto:privacy@laborplay.com">privacy@laborplay.com</a> ;
    pec:&#32;
    <a href="mailto:laborplay@legalmail.it">laborplay@legalmail.it</a>.
    </p>
    <p>
    PlayYourJob ne collecte pas d’informations et de données personnelles qui permettent de remonter à la personne qui les a fournies. L’accès à la plateforme est effectué par l’utilisation de jetons anonymes et d’identifiants de connexion générés automatiquement par le système pour le compte d’une société qui demande le service. Les informations saisies sur la plateforme PlayYourJob (sexe, âge, préférences de jeu) sont génériques et ne permettent pas de retracer l’identité du répondant. Les données fournies ne pourront être traitées que pour les finalités suivantes : exécution du service PlayYourJob avec une référence particulière à l’utilisation des jeux et à la participation au questionnaire de profilage afin de réaliser le profilage automatique job/match pour le compte de la société qui demande le service. La société qui demande le service est responsable de l’association des jetons aux utilisateurs et est la seule à connaître leurs données personnelles (nom, prénom, adresse électronique, etc.). Les données et informations de l’utilisateur sont traitées par Laborplay et renvoyées de manière anonyme concernant le jeton individuel à la société qui a demandé le service, sauf si Laborplay a été expressément désignée comme responsable du traitement conformément à la loi. Les cookies utilisés servent à optimiser l’expérience utilisateur et à faciliter la navigation entre les pages. Les données et réponses fournies sont conservées conformément à la loi sur les serveurs AWS Amazon situés aux États-Unis pour le compte de Laborplay.
    </p>
`,
};
